import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navigation from '../components/Navigation';
import InsuranceSection from '../components/InsuranceSection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const InsurancePage = () => {
  const [insuranceProviders, setInsuranceProviders] = useState([]);

  useEffect(() => {
    fetchInsuranceProviders();
  }, []);

  const fetchInsuranceProviders = async () => {
    try {
      const response = await axios.get(`${API}/insurance`);
      setInsuranceProviders(response.data);
    } catch {
      // Error handled silently
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO title="Insurance & Medicaid Accepted" description="SDORA Wellbeing accepts Medicaid, Maryland HealthChoice MCOs, Medicare, and most insurance for mental health therapy, PRP, and medication management in Pikesville, MD." path="/insurance" />
      <Navigation />
      <div className="bg-gradient-to-br from-blue-50 to-purple-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Accepted Insurance & Payment
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl">
            We accept Maryland Medicaid, Medicare, and self-pay. Contact us to verify your specific plan before your first visit.
          </p>
        </div>
      </div>

      <InsuranceSection insuranceProviders={insuranceProviders} />
      <Footer />
    </div>
  );
};

export default InsurancePage;